export default __webpack_public_path__ + "static/SayWhen-f246115a7416bac4c449638780d7daa9.png";